import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Dropdown, DropdownItem, Heading } from '@amzn/storm-ui';
import { useTranslation } from 'react-i18next';
import { CustomCard } from '../../../UiComponentsLibrary/CustomCard';
import FileUploadComponent from '../FileUploadComponent';
import {
  UPLOAD_CONFIGS,
  InventoryUploadConfig,
} from '../../config/uploadConfig';
import { URLS } from '../../../Shared/constants/url';
import { InventoryType } from '../../constants/FileUploadConstants';
import { DropdownContainer } from '../FileUploadComponent/FileUploadComponent.styles';
const { CONTEXTUAL, NON_CONTEXTUAL } = InventoryType;

const AllowlistUpload = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Normalize path by removing trailing slash and default to /allowlist
  const normalizedPath = location.pathname.replace(/\/$/, '') || URLS.ALLOWLIST;
  const config =
    UPLOAD_CONFIGS[normalizedPath] || UPLOAD_CONFIGS[URLS.ALLOWLIST];
    
  const [inventoryType, setInventoryType] = useState<string>(CONTEXTUAL);

  if (!config) {
    return <div>{t('invalid-upload-path')}</div>;
  }

  const isInventoryConfig = CONTEXTUAL in config;
  let fileUploadConfig;
  if (isInventoryConfig) {
    fileUploadConfig = (config as InventoryUploadConfig)[
      inventoryType as InventoryType
    ];
  } else {
    fileUploadConfig = config;
  }

  const renderInventoryDropDown = () => {
    return (
      <DropdownContainer>
        <Dropdown
          onChange={(value) => {
            setInventoryType(value);
          }}
          selectedValue={inventoryType}
          mobileFullScreen={false}
          multiple={false}
          fullWidth={true}
        >
          <DropdownItem value={CONTEXTUAL}>
            {t('contextual')}
          </DropdownItem>
          <DropdownItem value={NON_CONTEXTUAL}>
            {t('non-contextual')}
          </DropdownItem>
        </Dropdown>
      </DropdownContainer>
    );
  };

  return (
    <>
      <Heading size="medium">{t('allowlisting-header')}</Heading>
      <CustomCard title={t('file-upload-card-header')}>
        {isInventoryConfig && renderInventoryDropDown()}
        <FileUploadComponent
          key={fileUploadConfig.type}
          helpTip={t(fileUploadConfig.helpTip)}
          templateText={t(fileUploadConfig.templateText)}
          downloadLinkHref={fileUploadConfig.downloadLinkHref}
          downloadLinkText={t(fileUploadConfig.downloadLinkText)}
          uploadButtonLabel={t(fileUploadConfig.uploadButtonLabel)}
          type={fileUploadConfig.type}
        />
      </CustomCard>
    </>
  );
};

export default AllowlistUpload;
